var _g, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_5405_35532)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 120,
    fill: "#F6F3EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5405_35532",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 240,
    height: 240
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 120,
    fill: "#162E4F"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5405_35532)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.648 84.2991C191.648 82.0442 189.815 80.2139 187.559 80.2139H52.4845C50.2275 80.2139 48.3955 82.0442 48.3955 84.2991V172.915C48.3955 175.17 50.2275 177 52.4845 177H187.559C189.815 177 191.648 175.17 191.648 172.915V84.2991Z",
    fill: "#BF8B68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.45 137.628C131.45 136.826 130.797 136.174 129.994 136.174H108.291C107.488 136.174 106.835 136.826 106.835 137.628V147.966C106.835 148.768 107.487 149.419 108.291 149.419H129.994C130.797 149.419 131.45 148.768 131.45 147.966V137.628Z",
    fill: "#E5AB4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3955 119.478V121.603C48.9379 122.086 49.6135 122.478 50.3463 122.772L106.837 143.828V141.703L50.3463 120.647C49.6135 120.353 48.9394 119.961 48.3955 119.478ZM191.648 119.406C190.822 120.27 189.719 121.009 188.681 121.432L131.451 142.019V144.144L188.681 123.559C189.719 123.135 190.822 122.396 191.648 121.533V119.406Z",
    fill: "#A27659"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.835 141.703V143.828L115.251 146.964C116.933 147.382 118.328 147.611 119.685 147.611C120.903 147.611 122.089 147.426 123.423 147.03L131.45 144.144V142.019L123.423 144.906C122.089 145.302 120.903 145.486 119.685 145.486C118.328 145.486 116.933 145.257 115.25 144.84L106.835 141.703Z",
    fill: "#ECBB73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192.952 116.806C192.952 118.608 190.692 120.613 188.684 121.432L123.427 144.906C120.605 145.744 118.445 145.632 115.255 144.838L50.3489 120.647C48.5484 119.925 47.0957 118.608 47.0957 116.806V80.717C47.0957 77.0578 50.0698 74.0879 53.7323 74.0879H186.316C189.979 74.0879 192.953 77.0592 192.953 80.717V116.806",
    fill: "#D69D72"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 69.2627H193V82.371H47V69.2627Z",
    fill: "#FAC693"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.419 133.837C132.419 132.941 131.691 132.213 130.792 132.213H107.702C106.805 132.213 106.076 132.941 106.076 133.837V145.39C106.076 146.286 106.805 147.012 107.702 147.012H130.792C131.689 147.012 132.419 146.286 132.419 145.39V133.837Z",
    fill: "#FFCA65"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.2 75.8807H96.9953C96.679 75.8807 96.4229 76.0594 96.4229 76.281V77.1503C96.4229 77.3705 96.679 77.5506 96.9953 77.5506H104.2C104.516 77.5506 104.773 77.3719 104.773 77.1503V76.281C104.773 76.0609 104.516 75.8807 104.2 75.8807ZM140.925 75.6963H133.721C133.404 75.6963 133.148 75.875 133.148 76.0966V76.9659C133.148 77.186 133.403 77.3662 133.721 77.3662H140.925C141.24 77.3662 141.498 77.1875 141.498 76.9659V76.0966C141.498 75.875 141.24 75.6963 140.925 75.6963Z",
    fill: "#F9A254"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.165 75.9896C140.158 76.1383 140.152 76.6145 140.152 76.6187H134.486C134.486 76.6187 134.475 69.299 134.473 68.8343C134.439 65.8858 131.388 63.1161 127.598 63.0861C121.856 63.0703 116.112 63.0861 110.369 63.0861C106.742 63.0961 103.457 65.7128 103.444 68.8758V76.6159H97.7596C97.7596 76.6159 97.7596 76.2041 97.751 75.9896V68.2909C97.7682 63.6451 101.255 59.1724 106.241 57.6295C107.538 57.2277 108.909 57.0232 110.283 57.0118C116.066 56.9961 121.85 56.9961 127.633 57.0118C132.757 57.0561 137.714 60.1319 139.453 64.5517C139.923 65.7514 140.16 67.0226 140.165 68.2924V75.9896Z",
    fill: "#C4856A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_5405_35532",
    x: 0,
    y: 0,
    width: 240,
    height: 240,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5405_35532"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.0f0b9c1d619affcef638d03cf1da89ca.svg";
export { ForwardRef as ReactComponent };